import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconBusinessAiInterviewFill from './icon-business-ai-interview-fill.vue';

const IconBusinessAiInterviewFill = Object.assign(_IconBusinessAiInterviewFill, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconBusinessAiInterviewFill.name, _IconBusinessAiInterviewFill);
  }
});

export default IconBusinessAiInterviewFill;
